import React, { ReactNode } from "react";
import classnames from "classnames";
import BlockContent from "../BlockContent/BlockContent";
import LandingPageContentCard from "../LandingPageContentCard/LandingPageContentCard";
import { SanityRawContent } from "../../model/common";
import styles from "./LandingPageSectionCard.module.scss";
import { useIsRtl } from "../../utils/LayoutContext";

const LandingPageSectionCard = ({
  className,
  preamble,
  content
}: {
  className?: string;
  preamble?: ReactNode;
  content: SanityRawContent;
}) => {
  const isRtl = useIsRtl();
  return (
    <LandingPageContentCard
      className={classnames(styles.root, className)}
      dir={isRtl ? "rtl" : "ltr"}
    >
      {preamble}
      <BlockContent content={content} bodyVariant="default" />
    </LandingPageContentCard>
  );
};

export default LandingPageSectionCard;
